// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.participant-confirm-dialog {
    padding: var(--mdhui-padding-lg);
    gap: var(--mdhui-padding-md);
    max-width: 310px;
    width: 310px;
    min-height: 0;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,0.3);
    background: var(--mdhui-background-color-0);
    border: none;
    border-radius: var(--mdhui-card-border-radius);
    height: auto;
    max-height: fit-content;
    display: flex;
    flex-direction: column;
}

.participant-confirm-dialog::backdrop {
    background: var(--mdhui-modal-overlay-color);
}

.participant-confirm-message {
    margin: 0;
    font-size: 16px;
    line-height: 1.4;
    text-align: center;
    color: var(--mdhui-text-color-0);
    white-space: pre-line;
}

.participant-confirm-buttons {
    display: flex;
    gap: var(--mdhui-padding-xs);
}

.participant-confirm-dialog .continue-button {
    display: inline-block;
    margin-top: 0;
    font-size: 17px;
    padding: 16px;
    background: var(--default-primary-color);
    color: #FFF;
    font-weight: bold;
    border: solid 1px var(--default-primary-color);
    border-radius: 6px;
    cursor: pointer;
    flex: 1;
    width: auto;
    box-sizing: border-box;
    line-height: 17px;
}

.participant-confirm-dialog .continue-button:disabled {
    background: var(--mdhui-background-color-0) !important;
    color: var(--mdhui-text-color-2) !important;
    border-color: var(--mdhui-border-color-2) !important;
    cursor: default;
}

.participant-confirm-dialog .participant-confirm-cancel.continue-button {
    background: var(--mdhui-background-color-0);
    color: var(--mdhui-text-color-2);
    border-color: var(--mdhui-border-color-2);
}
`, "",{"version":3,"sources":["webpack://./src/components/MyDataHelps/ConfirmDialog/ParticipantConfirm.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,sCAAsC;IACtC,2CAA2C;IAC3C,YAAY;IACZ,8CAA8C;IAC9C,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,eAAe;IACf,aAAa;IACb,wCAAwC;IACxC,WAAW;IACX,iBAAiB;IACjB,8CAA8C;IAC9C,kBAAkB;IAClB,eAAe;IACf,OAAO;IACP,WAAW;IACX,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,sDAAsD;IACtD,2CAA2C;IAC3C,oDAAoD;IACpD,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,gCAAgC;IAChC,yCAAyC;AAC7C","sourcesContent":[".participant-confirm-dialog {\n    padding: var(--mdhui-padding-lg);\n    gap: var(--mdhui-padding-md);\n    max-width: 310px;\n    width: 310px;\n    min-height: 0;\n    overflow: hidden;\n    box-shadow: 0 4px 20px rgba(0,0,0,0.3);\n    background: var(--mdhui-background-color-0);\n    border: none;\n    border-radius: var(--mdhui-card-border-radius);\n    height: auto;\n    max-height: fit-content;\n    display: flex;\n    flex-direction: column;\n}\n\n.participant-confirm-dialog::backdrop {\n    background: var(--mdhui-modal-overlay-color);\n}\n\n.participant-confirm-message {\n    margin: 0;\n    font-size: 16px;\n    line-height: 1.4;\n    text-align: center;\n    color: var(--mdhui-text-color-0);\n    white-space: pre-line;\n}\n\n.participant-confirm-buttons {\n    display: flex;\n    gap: var(--mdhui-padding-xs);\n}\n\n.participant-confirm-dialog .continue-button {\n    display: inline-block;\n    margin-top: 0;\n    font-size: 17px;\n    padding: 16px;\n    background: var(--default-primary-color);\n    color: #FFF;\n    font-weight: bold;\n    border: solid 1px var(--default-primary-color);\n    border-radius: 6px;\n    cursor: pointer;\n    flex: 1;\n    width: auto;\n    box-sizing: border-box;\n    line-height: 17px;\n}\n\n.participant-confirm-dialog .continue-button:disabled {\n    background: var(--mdhui-background-color-0) !important;\n    color: var(--mdhui-text-color-2) !important;\n    border-color: var(--mdhui-border-color-2) !important;\n    cursor: default;\n}\n\n.participant-confirm-dialog .participant-confirm-cancel.continue-button {\n    background: var(--mdhui-background-color-0);\n    color: var(--mdhui-text-color-2);\n    border-color: var(--mdhui-border-color-2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
